/**
 * Mock mode. `import.meta.env.DEV` is a build-time constant, so in a production build this is
 * `false` and every branch that imports src/mock is removed by the bundler.
 */
export const MOCK = import.meta.env.DEV && import.meta.env.VITE_MOCK === "1";

/** Build-time configuration. Every value is optional and none of them is a secret. */
export const config = {
  /** Base URL of apps/server. Empty = same origin. */
  apiUrl: (import.meta.env.VITE_API_URL as string | undefined) ?? "",
  /**
   * Public, keyless Solana RPC used by the payer's own browser to simulate the payment before the
   * wallet signs, and as the send fallback. Null = no simulation.
   */
  solanaRpcUrl: (import.meta.env.VITE_SOLANA_RPC_URL as string | undefined) || null,
  /** Deployed MikodesPayRouter on Base (same value as the server's BASE_ROUTER_ADDRESS). Empty = Base wallet pay off. */
  baseRouterAddress: (import.meta.env.VITE_BASE_ROUTER_ADDRESS as string | undefined) || null,
  /** WalletConnect is offered only when the operator supplies a project id. */
  walletConnectProjectId: (import.meta.env.VITE_WALLETCONNECT_PROJECT_ID as string | undefined) || null,
  /** Local development only — see src/mock/mockApi.ts. Always false in a production build. */
  mock: MOCK,
};
